<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import TileInfoBox from "tile-info-box"

export default {
  mixins: [fandomBasicMixin],
  components: {
    TileInfoBox
  },
  props: ["validFrom", "validTo"],
  mounted() {
    Vue.nextTick(() => {
      this.registerAnimation();
    });
  },
  computed: {
    contentClasses() {
      let classes = [this.contentType];
      if (this.content.theme) {
        classes.push(`${this.content.theme}-theme`)
      }
      return classes;
    },
  }
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="contentClasses"
    class="inview_animate py-4"
    v-if="isContentVisibleToUser()" 
    stripe-info-box-component
  >
    <div class="container-md px-3 mx-md">
      <tile-info-box class="mx-0 mx-md" :content="content" :opt-container-content="containerContent" :theme="content.theme" :validFrom="validFrom" :validTo="validTo"></tile-info-box>
    </div>
  </div>
</template>

<style lang="scss">
</style>